import { KeyValue } from '@angular/common';
import { RepeatType } from '@syncfusion/ej2-angular-schedule';
import { Component, OnInit, Input } from '@angular/core';
import {
  FrequencyEndType,
  FrequencyRepeatTypes,
  RecurringFrequency,
  RecurringInvoiceConfig,
  SettingsRecurringInvoice,
} from 'src/app/invoice/models/invoice.model';
import * as moment from 'moment';
import { RecurringInvoiceService } from 'src/app/invoice/services/recurring-invoice.service';
import { ControlContainer, NgModelGroup } from '@angular/forms';
import { mapFrequencyRule } from 'src/app/invoice/utilities';

@Component({
  selector: 'app-payment-schedule',
  templateUrl: './payment-schedule.component.html',
  styleUrls: ['./payment-schedule.component.scss'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgModelGroup }],
})
export class PaymentScheduleComponent implements OnInit {
  @Input() parent: any;
  loaded = false;
  constructor(public recurringInvoiceService: RecurringInvoiceService) {}

  daysInWeek = {
    SU: 'S',
    MO: 'M',
    TU: 'T',
    WE: 'W',
    TH: 'T',
    FR: 'F',
    SA: 'S',
  };

  repeatitionLabel = {
    1: 'Day/s',
    2: 'Week/s',
    3: 'Month/s',
    4: 'Year/s',
  };
  // Recurrence
  reccurenceEditorFrequencies: RepeatType[] = [
    'daily',
    'weekly',
    'monthly',
    'yearly',
  ];
  cardsOnFile: any = [];

  ngOnInit(): void {
    this.parent.recurringInvoiceConfig = new RecurringInvoiceConfig();
    this.parent.recurringInvoiceConfig.RecurringFrequency =
      new RecurringFrequency();
      
    this.setFrequencyDefaults();
    this.getRecurringInfo();

    if (!this.parent.recurring.data) {
      this.loadRecurringInvoiceSettings();
    } 
  
    this.loaded = true;
  }

  setFrequencyDefaults() {
    this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay = moment()
      .format('dd')
      .toUpperCase();
    this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray = [
      moment().format('dd').toUpperCase(),
    ];
    this.parent.recurringInvoiceConfig.RecurringFrequency.ByMonth =
      +moment().format('M');
    this.parent.recurringInvoiceConfig.RecurringFrequency.ByMonthDay =
      +moment().format('D');
  }

  loadRecurringInvoiceSettings() {
    this.recurringInvoiceService
      .getSettings()
      .subscribe((res: SettingsRecurringInvoice) => {
        this.parent.settingsRecurringInvoice = res;

        if (this.parent.settingsRecurringInvoice.notificationSchedule) {
          this.parent.recurringInvoiceConfig.ReminderFrequencyType =
            res.notificationSchedule.frequencyType;
          this.parent.recurringInvoiceConfig.ReminderFrequencyValue =
            res.notificationSchedule.frequencyValue;
        }
      });
  }

  changeRecurringFrequencyType(event) {
    const dayOfTheWeek = moment().format('dd').toUpperCase();
    this.parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType =
      +event.target.value;

    if (event.target.value == 3) {
      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay =
        dayOfTheWeek;
    } else {
      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay =
        dayOfTheWeek;
      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray =
        [];
      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray.push(
        dayOfTheWeek
      );
    }
  }

  changeStartDate(event: any) {
    this.parent.recurringInvoiceConfig.StartDate = event;

    if (!this.parent.isEditView) {
      this.parent.dtInvoiceDate = event;
    }
  }

  changeRecurringByDay(day: string, type: string) {
    if (type === 'multiple') {
      const isSelected =
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray.find(
          (e) => e === day
        );
      if (isSelected) {
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray =
          this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray.filter(
            (e) => e !== day
          );
      } else {
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray.push(
          day
        );
      }

      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay =
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray.join(
          ','
        );
    } else {
      this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay = day;
    }
  }

  changeRecurringDayType(type: string) {
    this.parent.recurringInvoiceConfig.RecurringFrequency.DayType = type;
  }

  changeRecurringBySetPos(event) {
    this.parent.recurringInvoiceConfig.RecurringFrequency.BySetPos =
      +event.target.value;
  }

  changeRecurringByMonth(event) {
    this.parent.recurringInvoiceConfig.RecurringFrequency.ByMonth =
      +event.target.value;
  }

  getRecurringInfo() {
    const schedule = mapFrequencyRule(this.parent.recurring.frequency);

    this.parent.recurringInvoiceConfig.RecurringPaymentId =
      this.parent.recurring.id;
    this.parent.recurringInvoiceConfig.RecurringFrequency.FrequencyType =
      schedule.frequencyType;
    this.parent.recurringInvoiceConfig.RecurringFrequency.Interval =
      parseInt(schedule.interval);

    if (this.parent.recurring.data) {
      this.parent.recurringInvoiceConfig.ReminderFrequencyType =
        this.parent.recurring.data.reminderFrequencyType;
      this.parent.recurringInvoiceConfig.ReminderFrequencyValue =
        parseInt(this.parent.recurring.data.reminderFrequencyValue)
    }

    switch (
      this.parent.recurringInvoiceConfig.RecurringFrequency
        .FrequencyType
    ) {
      case FrequencyRepeatTypes.Daily:
        break;
      case FrequencyRepeatTypes.Weekly:
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay =
          schedule.byDay;
        this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray =
          schedule.byDay.split(',');
        break;
      case FrequencyRepeatTypes.Monthly:
      case FrequencyRepeatTypes.Yearly:
        if (parseInt(schedule.byMonthDay)) {
          this.parent.recurringInvoiceConfig.RecurringFrequency.DayType =
            'day';
          this.parent.recurringInvoiceConfig.RecurringFrequency.ByMonthDay =
            parseInt(schedule.byMonthDay);
        } else {
          this.parent.recurringInvoiceConfig.RecurringFrequency.BySetPos =
            parseInt(schedule.bySetPos);
          this.parent.recurringInvoiceConfig.RecurringFrequency.ByDay =
            schedule.byDay;
          this.parent.recurringInvoiceConfig.RecurringFrequency.ByDayArray =
            schedule.byDay.split(',');
          this.parent.recurringInvoiceConfig.RecurringFrequency.DayType =
            'month';
        }

        if (
          this.parent.recurringInvoiceConfig.RecurringFrequency
            .FrequencyType === FrequencyRepeatTypes.Yearly
        ) {
          this.parent.recurringInvoiceConfig.RecurringFrequency.ByMonth =
            parseInt(schedule.byMonth);
        }
        break;
    }
  
    if (schedule.until) {
      this.parent.recurringInvoiceConfig.RecurringFrequency.EndType =
        FrequencyEndType.Until;
      this.parent.recurringInvoiceConfig.RecurringFrequency.Until =
        schedule.until;
    } else if (parseInt(schedule.count)) {
      this.parent.recurringInvoiceConfig.RecurringFrequency.EndType =
        FrequencyEndType.Count;
      this.parent.recurringInvoiceConfig.RecurringFrequency.Count =
        parseInt(schedule.count);
    } else {
      this.parent.recurringInvoiceConfig.RecurringFrequency.EndType =
        FrequencyEndType.Never;
    }
  }

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };
}
